const getters = {
    batchProductions: (state) => state.batchProductions,
    loading: state => state.loading
};

export default getters;